import React, { useEffect, useState } from "react";
import { Card, Grid, Image } from "semantic-ui-react";
import "./skills.css";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

const Skills = (props) => {
  const [data, setData] = useState(null);
  const [playlists, setPlaylists] = useState([]);

  useEffect(() => {
    if (props.playlistsData) {
      setData(props.playlistsData);
    }
  }, [props.playlistsData]);
  useEffect(() => {
    if (data) {
      let storingObject = Object.keys(data);
      let activeObject = [];
      if (storingObject.length > 0) {
        activeObject = storingObject.map((key) => {
          if (data[key].active) {
            return {
              id: data[key].id,
              title: data[key].title,
              playlistUrl: data[key].playlistUrl,
              thumbnailUrl: data[key].thumbnailUrl,
              modifiedAt: data[key].modifiedAt,
              createdAt: data[key].createdAt,
              active: data[key].active,
            };
          }
        });
        // this filtering is for undefined data
        activeObject = activeObject.filter((active) => active);
      }
      setPlaylists(activeObject);
    }
  }, [data]);
  let card;
  if (playlists.length > 0) {
    card = playlists.map((playlist) => {
      if (playlist.active) {
        return (
          <Grid.Column mobile={16} tablet={8} computer={4}>
            <Card>
              <Image src={playlist.thumbnailUrl} />
              <Card.Content>
                <Card.Header>
                  <span>{playlist.title}</span>
                </Card.Header>
              </Card.Content>
              <Card.Content extra>
                <a
                  target="_blank"
                  href={playlist.playlistUrl}
                  rel="noopener noreferrer"
                >
                  VIEW FULL PLAYLIST
                </a>
              </Card.Content>
            </Card>
          </Grid.Column>
        );
      }
    });
  } else {
    card = <p className="not-found">There's No Data Here</p>;
  }
  return (
    <>
      <div className="HomeContainer">
        <div className="PlaylistBanner">
          <h1>Skills Video Playlists</h1>
          <Grid divided="vertically">
            <Grid.Row stackable="true" columns={2}>
              {card}
            </Grid.Row>
          </Grid>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    playlistsData: state.firestore.ordered.skillsPlaylists,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "skillsPlaylists",
    },
  ])
)(Skills);
